import Vue from 'vue'
import Router from 'vue-router'
import loginView from '@/views/login'
import extraInfoLayout from '@/views/extraInfoLayout'
import maErrorView from '@/views/error'
import * as Settings from '@/infra/settings'
import loginSsoView from '@/views/loginSso'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '',
      name: 'root'
    },
    {
      path: '/login', // NORMAL LOGIN
      name: 'login',
      component: loginView
    },
    {
      path: '/auth/login', // SSO
      name: 'login-sso',
      component: loginSsoView
    },
    {
      path: '/claim/extraInfo/:sinisterId',
      name: 'extraInfo',
      component: extraInfoLayout
    },
    {
      path: '/error',
      name: 'error',
      component: maErrorView
    },
    {
      path: '*',
      redirect: 'error'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = Settings.getTokenStorage()
  if (to.name !== 'login' && to.name !== 'login-sso' && !isAuthenticated) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
